<template>
  <div class="empty">
    <img src="/static/images/empty.png" alt />
    <p v-if="info">{{info}}</p>
  </div>
</template>
<script>
export default {
  props: ["info"]
};
</script>
<style scoped>
.empty {
  padding: 32px 0;
  text-align: center;
  font-size: 0;
}
.empty img {
  width: 200px;
  height: 200px;
}
.empty p {
  margin: 0;
  padding: 0 60px;
  color: #969799;
  font-size: 14px;
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/other/empty.vue